import repository from 'client/repository';
import alertActions from 'areas/alert/actions';
import isStringSet from 'utilities/is/isStringSet';

const Prefix = 'INITIALISE';
const CardNotFoundMessage = "Card not found, it may be part of another scheme (check first two digits of card number match those for your version)";

export default function initialise(qrCode, callback) {

    function requested() {
        return { type: `${Prefix}_REQUESTED`, qrCode };
    }

    function success(response) {
        return { type: `${Prefix}_SUCCESS`, qrCode, ...response };
    }

    function failure(error) {
        return { type: `${Prefix}_FAILURE`, qrCode, failureReason: error };
    }

    function failureMessage(error) {
        if (error === 'Person not found') {
            error = CardNotFoundMessage;
        }

        return error;
    }

    return async (dispatch) => {
        dispatch(requested(qrCode));

        try {
            const response = await repository.auth.initialise(qrCode);

            if (isStringSet(response.failureReason)) {
                const message = failureMessage(response.failureReason);
                dispatch(failure(response.failureReason));
                dispatch(alertActions.error(message, callback));
            } else {
                dispatch(success(response));
            }

        } catch (error) {
            dispatch(alertActions.error(error.failureReason || error.toString()));
            dispatch(failure(error.failureReason || error.toString()));
        }
    };
}